import { api } from ".";

const cacheUrlV1 = "/v1/authCache";

export const getCacheInstanceNames = async (): Promise<string[]> => {
  const response = await api.get<string[]>(`${cacheUrlV1}/instanceNames`);
  return response?.data ?? [];
};

export const clearAuthCache = async () => {
  const response = await api.get(`${cacheUrlV1}/clearAll`);
  return response?.status === 200;
};

export const clearCacheByNames = async (instanceNames: string[]) => {
  const response = await api.post(`${cacheUrlV1}/clearByNames`, instanceNames);
  return response?.status === 200;
};
